import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 41px;
	padding: 0 20px;
	margin-top: 64px;

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 0 20px;
`;

const StyledOptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledOption = styled.div`
	background: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
	padding: 20px;
`;

const StyledPhoneOption = styled(StyledOption)`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledAsapOption = styled(StyledOption)`
	display: grid;
	grid-template-columns: auto 1fr auto;
	gap: 10px;
`;

const StyledTextAreaContainer = styled.div`
	position: relative;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	padding: 20px;
`;

const StyledTextArea = styled.textarea`
	width: 300px;
	height: 96px;
	background-color: transparent;
	border: none;
	outline: none;
	resize: none;
	overflow-y: scroll;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;

	&:placeholder {
		color: rgba(255, 255, 255, 0.25);
	}

	&::-webkit-scrollbar {
		display: none;
	}
	scrollbar-width: none;
`;

const StyledTextAreaStatsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 10px;
`;

const StyledPriceContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 14px;
	gap: 10px;
	margin-top: 70px;
`;

export {
	StyledAsapOption,
	StyledContainer,
	StyledHead,
	StyledOptionsContainer,
	StyledPhoneOption,
	StyledPriceContainer,
	StyledTextArea,
	StyledTextAreaContainer,
	StyledTextAreaStatsContainer,
};
